import {Component, PropsWithChildren, ReactNode } from 'react'
import ResponsiveContainer from '../components/responsive-container'
import ResponsiveContent from '../components/responsive-content'
import './top-nav.less'

interface Props {
  isMenuInvisible?: boolean
  children?: ReactNode
}

interface State {
  isOpen: boolean
}

export function TopNavLinks(props: PropsWithChildren<{}>) {
  return <ResponsiveContainer className="links" centerContents={true}>
    <ResponsiveContent className="links-inner">
      {props.children}
    </ResponsiveContent>
  </ResponsiveContainer>
}

export default class TopNav extends Component<Props, State> {
  state: State = {
    isOpen: false
  }

  constructor(props: Props) {
    super(props)

    this.handleHamburgerClicked = this.handleHamburgerClicked.bind(this);
  }

  handleHamburgerClicked() {
    this.setState((state, props) => {
      return {
        isOpen: !state.isOpen
      }
    })
  }

  render() {
    const {children,isMenuInvisible} = this.props;
    const {isOpen} = this.state;
    let className = "top-nav";
    if (isOpen) {
      className += " opened";
    }

    return <ResponsiveContainer className={className} centerContents={false}>
      <ResponsiveContent className="top-nav-inner">
        {!isMenuInvisible &&
          <button className="hamburger" onClick={this.handleHamburgerClicked}>
          </button>
          }
          {children}
      </ResponsiveContent>
    </ResponsiveContainer>
  }
}
